import { OrdinalIcon } from "@/components/OrdinalIcon";

type ChatLoadingIndicatorProps = {
  message: string;
  compact?: boolean;
};

export function ChatLoadingIndicator({ message, compact = false }: ChatLoadingIndicatorProps) {
  const iconClass = compact ? "h-10 w-10 animate-logo-pulse" : "h-14 w-14 lg:h-16 lg:w-16 animate-logo-pulse";

  return (
    <div
      className={compact ? "flex flex-col items-center gap-1 m-2" : "flex flex-col items-center gap-1 lg:gap-2 m-4"}
      aria-live="polite"
      role="status"
    >
      <OrdinalIcon className={iconClass} fill="hsl(var(--primary) / 0.05)" />
      <p className={compact ? "text-sm text-muted-foreground text-center" : "text-base lg:text-lg text-muted-foreground text-center"}>
        {message}
      </p>
    </div>
  );
}
